import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - MENU ITEM ||============================== //

export default function MenuItem(theme: Theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: `${theme.palette.text.primary} !important`,
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.action.selected
          }
        }
      }
    }
  };
}

